import React from 'react'
import { Link } from 'gatsby'

// Styles
import '../scss/components/_logo.scss'

export default () => (
  <Link to="/" className="logo">
    <h1>datenguide</h1>
  </Link>
)
